import React, { FC, useEffect, useState } from "react";
import FileUploader from "devextreme-react/file-uploader";
import { IInputProps } from "../../modules/form";
import Axios from "axios";
import { CreateNotification } from "../../components/notifier";
import "react-photo-view/dist/react-photo-view.css";

export const UploadFile: FC<IInputProps> = ({ value, onChange, multiple = false }) => {
  const [imageData, setImageData] = useState(value || (null as any));
  const fileExtensions = [".jpg", ".jpeg", ".gif", ".png"];
  const [imageBase64String, setImageBase64String] = useState(value || (null as any));

  const handleFileUpload = async (event: any) => {
    if (multiple) {
      const files = event.value ? [...event.value] : null;

      const listFile: string[] = [];

      files?.forEach(async (file) => {
        const reader: any = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // const base64Data = reader.result.split(",")[1];
          // const blob = new Blob([atob(base64Data)], { type: file.type });
          const imageDataUrl = reader.result;
          setImageBase64String(imageDataUrl);
        };
        const formData = new FormData();
        formData.append("file", file);

        try {
          const response = await Axios.post(
            "https://viagsapi.azurewebsites.net/api/uploadfile/upload-file-img",
            formData,
          );
          if (response.data.statusCode === 200) {
            const imageData = response?.data.data; // Adjust this based on the server response
            setImageData(imageData);
            listFile.push(imageData);
          } else {
            CreateNotification({
              title: "Thông báo",
              body: "Định dạng này không hợp lệ, vui lòng chọn các định dạng khác (.png, .jpg, .jpeg, .gif)",
              icon: "/icons/error.png",
            });
          }
        } catch (error) {
          // Handle errors
          console.error(error);
        }
      });

      (await onChange) && onChange(listFile);
    } else {
      const file = event.value ? event.value[0] : null;
      if (file) {
        const reader: any = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // const base64Data = reader.result.split(",")[1];
          // const blob = new Blob([atob(base64Data)], { type: file.type });
          const imageDataUrl = reader.result;
          setImageBase64String(imageDataUrl);
        };
        const formData = new FormData();
        formData.append("file", file);

        try {
          const response = await Axios.post(
            "https://viagsapi.azurewebsites.net/api/uploadfile/upload-file-img",
            formData,
          );
          if (response.data.statusCode === 200) {
            const imageData = response?.data.data; // Adjust this based on the server response
            setImageData(imageData);
            onChange && onChange(imageData);
          } else {
            setImageBase64String(null);
            setImageData(null);
            CreateNotification({
              title: "Thông báo",
              body: "Định dạng này không hợp lệ, vui lòng chọn các định dạng khác (.png, .jpg, .jpeg, .gif)",
              icon: "/icons/error.png",
            });
          }
        } catch (error) {
          // Handle errors
          console.error(error);
        }
      }
    }
  };

  const openFullscreen = () => {
    window.open(imageData);
  };

  useEffect(() => {
    setImageData(value || "");
  }, [value]);

  return (
    <div className="main-block">
      <div className="file-uploader-block d-flex justify-content-start align-items-center">
        <FileUploader
          multiple={multiple}
          uploadMode="useForm"
          allowCanceling={true}
          stylingMode="outlined"
          readyToUploadMessage="Tải ảnh thành công"
          invalidMaxFileSizeMessage="Kích thước ảnh quá lớn"
          uploadFailedMessage="Tải ảnh lên không thành công"
          invalidFileExtensionMessage="Loại tệp tin không được phép, vui lòng chọn lại."
          selectButtonText={multiple ? "Chọn 1 hoặc nhiều ảnh" : "Nhấn vào để chọn ảnh"}
          labelText="hoặc Kéo thả ảnh vào đây"
          onValueChanged={handleFileUpload}
          maxFileSize={4000000}
          allowedFileExtensions={fileExtensions}
        />
        {imageBase64String && (
          <img
            src={imageBase64String}
            width={100}
            height={100}
            alt=""
            loading="lazy"
            id="image"
            style={{ cursor: "pointer" }}
            onClick={openFullscreen}
          />
        )}
      </div>
    </div>
  );
};
